module.exports = __webpack_public_path__ + "img/_contact.822133c4.svg";